import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const ImageBackground = styled.div`
    background-position: center center;
    background-size: cover;

    ${props => props.extraSmall && {
        backgroundImage: `image-set(
            url(${props.extraSmall}) 1x,
            url(${props.extraSmall2x}) 2x)`,
        height: '340px',
        width: '310px',
    }}

    /**
        Instead of using breakpoints.small here, we use
        a minimum width that's slightly smaller so we can load
        wide images as soon as they are available.
    */
    @media (min-width: 375px) { {
        ${props => props.small && {
        backgroundImage: `image-set(
            url(${props.extraSmall}) 1x,
            url(${props.extraSmall2x}) 2x)`,
        height: '398px',
        width: '363px',
    }}
    }

    /**
        Instead of using breakpoints.small here, we use
        a minimum width that's slightly smaller so we can load
        wide images as soon as they are available.
    */
    @media (min-width: 520px) { {
        ${props => props.small && {
        backgroundImage: `image-set(
            url(${props.small}) 1x,
            url(${props.small2x}) 2x)`,
        height: '350px',
        width: '510px',
    }}
    }

    @media ${breakpoints.medium} {
        ${props => props.medium && {
        backgroundImage: `image-set(
            url(${props.medium}) 1x,
            url(${props.medium2x}) 2x)`,
        height: '375px',
        width: '540px',
    }}
    }

    @media ${breakpoints.large} {
        ${props => props.medium && {
        backgroundImage: `image-set(
            url(${props.medium}) 1x,
            url(${props.medium2x}) 2x)`,
        height: '455px',
        width: '620px',
    }}
    }

    @media ${breakpoints.extraLarge} {
        ${props => props.extraLarge && {
        backgroundImage: `image-set(
            url(${props.extraLarge}) 1x,
            url(${props.extraLarge2x}) 2x)`,
        height: '375px',
        width: '540px',
    }}
    }
`;
